import { useEffect, useState } from "preact/compat";
import algolia from "../algolia";
import { connectSearchBox } from "instantsearch.js/es/connectors";

function SearchBox(props) {
  const [searchValue, setSearchValue] = useState(undefined);

  const renderSearchBox = (renderOptions, isFirstRender) => {
    const { query, refine, widgetParams } = renderOptions;
    const input = widgetParams.input;

    if (isFirstRender) {
      window.quickSelect = (item) => {
        refine(item);
      };
      window.clearBallisticSearchInput = () => {
        refine("");
      };
      input.addEventListener("input", (event) => {
        refine(event.target.value);
        // clearTimeout(timerId);
        // timerId = setTimeout(() => refine(event.target.value), 500);
      });
    }
    setSearchValue(query);
    input.value = query;
  };

  const customSearchBox = connectSearchBox(renderSearchBox);

  useEffect(() => {
    algolia().searchIndex.addWidgets([
      customSearchBox({
        input: document.getElementById("ballistic-search-input"),
      }),
    ]);
  }, []);

  function onClose() {
    window.clearBallisticSearchInput();
    // props.onClose();
  }

  return (
    <div
      class={`${
        props.focus ? `outline-none shadow-outline ` : ``
      } items-center flex bg-white border border-gray-400 rounded-lg px-1 w-full appearance-none leading-normal`}
    >
      <label for='search'>
        <svg
          class='w-6 h-6'
          fill='none'
          stroke='currentColor'
          viewBox='0 0 24 24'
          xmlns='http://www.w3.org/2000/svg'
        >
          <path
            stroke-linecap='round'
            stroke-linejoin='round'
            stroke-width='2'
            d='M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z'
          ></path>
        </svg>
      </label>
      <input
        onFocus={props.onFocus}
        onBlur={props.onBlur}
        id='ballistic-search-input'
        class='focus:outline-none w-full px-2 py-2 h-10 text-base placeholder-current'
        placeholder='Search a keyword or phrase'
      />
      {searchValue && (
        <a onClick={onClose} class='pr-1 items-center'>
          <svg
            className='w-8 h-8'
            fill='none'
            stroke='currentColor'
            viewBox='0 0 24 24'
            xmlns='http://www.w3.org/2000/svg'
          >
            <path
              strokeLinecap='round'
              strokeLinejoin='round'
              strokeWidth={2}
              d='M6 18L18 6M6 6l12 12'
            />
          </svg>
        </a>
      )}
    </div>
  );
}

export default SearchBox;



// WEBPACK FOOTER //
// ./components/SearchBox.js